import React, { useRef, useState, useEffect } from "react";
import { audioController } from './AudioControl';

export function SoundPlayer({ soundFile }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        // 组件卸载时清理
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioController.unregisterAudio(audioRef.current);
                audioRef.current = null;
            }
        };
    }, []);

    if (!soundFile) {
        return (
            <button style={{ visibility: "hidden", minWidth: "35px" }}>
                ▶️
            </button>
        );
    }

    const togglePlay = () => {
        if (!audioRef.current) {
            audioRef.current = new Audio(soundFile);
            
            // 注册音频实例
            audioController.registerAudio(audioRef.current);
            
            // 音频结束时的处理
            audioRef.current.onended = () => {
                setIsPlaying(false);
                audioController.unregisterAudio(audioRef.current);
            };
        }

        const audio = audioRef.current;
        
        if (isPlaying) {
            // 暂停当前音频
            audio.pause();
            audioController.unregisterAudio(audio);
        } else {
            // 停止所有其他音频，然后播放当前音频
            audioController.stopOtherAudios(audio);
            audio.play();
        }
        
        setIsPlaying(!isPlaying);
    };

    return (
        <button 
            style={{ 
                minWidth: "50px", 
                fontSize: "30px",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "5px"
            }} 
            onClick={togglePlay}
            aria-label={isPlaying ? "Pause audio" : "Play audio"}
        >
            {isPlaying ? "⏸️" : "▶️"}
        </button>
    );
}
